<app-menu></app-menu>
<div class="editor-page">
  <div class="editor-card">
    <header>
      <h1>{{ editorTitle }}</h1>
      <p>{{ editorDescription }}</p>
    </header>

    <div class="editor-layout">
      <div class="preview-panel">
        <div class="preview-card">
          <div class="post-header">
            <div class="post-avatar">{{ currentUser?.name?.charAt(0) || 'U' }}</div>
            <div>
              <strong>{{ currentUser?.name || 'Usuário' }}</strong>
              <span> • Agora mesmo</span>
            </div>
          </div>
          <p class="post-text">{{ form.content_text || 'Seu conteúdo aparecerá aqui.' }}</p>
          <ng-container *ngIf="isCarouselMode; else singlePreview">
            <div class="carousel-preview-grid" *ngIf="carouselPreviews.length; else previewHint">
              <div class="preview-main">
                <img [src]="carouselPreviews[0]" alt="Imagem principal">
              </div>
              <div class="preview-side">
                <div class="preview-thumb" *ngFor="let preview of carouselPreviews.slice(1,4); let idx = index">
                  <img [src]="preview" alt="Imagem adicional">
                  <div class="more-overlay" *ngIf="idx === 2 && carouselPreviews.length > 4">
                    +{{ carouselPreviews.length - 4 }}
                  </div>
                </div>
              </div>
            </div>
            <ng-template #previewHint>
              <p class="carousel-placeholder">Adicione até {{ maxCarouselImages }} imagens para montar o carrossel.</p>
            </ng-template>
          </ng-container>
          <ng-template #singlePreview>
            <ng-container [ngSwitch]="filePreviewType">
              <ng-container *ngSwitchCase="'image'">
                <img *ngIf="filePreview" [src]="filePreview" alt="Pré-visualização">
              </ng-container>
              <ng-container *ngSwitchCase="'video'">
                <video *ngIf="filePreview" [src]="filePreview" controls muted loop></video>
              </ng-container>
              <div *ngSwitchCase="'document'" class="document-preview-card">
                <mat-icon>description</mat-icon>
                <div>
                  <p>{{ documentPreviewName || 'Documento selecionado' }}</p>
                  <small>O arquivo será disponibilizado para confirmação de leitura.</small>
                </div>
              </div>
              <p *ngSwitchDefault class="preview-placeholder">Selecione um arquivo para visualizar.</p>
            </ng-container>
          </ng-template>
          <div class="post-footer">
            <span><mat-icon>favorite</mat-icon> Curtir</span>
            <span><mat-icon>chat_bubble_outline</mat-icon> Comentar</span>
          </div>
        </div>
      </div>

      <form class="form-panel" (ngSubmit)="submitPost()">
        <div class="top-controls">
          <label>
            Tipo de post
            <select [(ngModel)]="form.post_type" name="post_type" (ngModelChange)="onPostTypeChange($event)" [disabled]="editMode || form.show_popup || forceDocumentMode">
              <option value="image">Imagem</option>
              <option value="video">Vídeo</option>
              <option value="carousel">Carrossel</option>
            </select>
          </label>

          <label>
            Status
            <select [(ngModel)]="form.status" name="status" (ngModelChange)="onStatusChange($event)">
              <option value="published">Publicar agora</option>
              <option value="scheduled">Agendado</option>
              <option value="draft">Rascunho</option>
            </select>
          </label>
        </div>

        <label class="schedule-field">
          Agendar publicação
          <input type="datetime-local" [(ngModel)]="form.scheduled_at" name="scheduled_at" (change)="onScheduleChange()">
        </label>

        <div class="existing-media" *ngIf="editMode">
          <p>Arquivos atuais desta publicação:</p>
          <div class="media-thumbs">
            <ng-container *ngFor="let media of existingMediaUrls">
              <img *ngIf="form.post_type !== 'video'; else videoIcon" [src]="formatExistingMedia(media)" alt="Mídia existente">
              <ng-template #videoIcon>
                <div class="video-icon">
                  <mat-icon>videocam</mat-icon>
                </div>
              </ng-template>
            </ng-container>
            <p *ngIf="!existingMediaUrls.length">Post apenas com texto.</p>
          </div>
          <small class="media-hint">Para alterar arquivos, crie uma nova postagem.</small>
        </div>

        <div class="drop-area"
             *ngIf="!editMode"
             [class.dragging]="dragging"
             [class.carousel-mode]="isCarouselMode"
             (dragover)="onDragOver($event)"
             (dragleave)="onDragLeave($event)"
             (drop)="onDrop($event)"
             (click)="triggerFileInput()">
          <input type="file"
                 #fileInput
                 [attr.multiple]="isCarouselMode ? '' : null"
                 [attr.accept]="uploadAccept"
                 (change)="onFileChange($event)">
          <p class="popup-note" *ngIf="form.show_popup">Popups aceitam apenas uma imagem estática.</p>
          <ng-container *ngIf="isCarouselMode; else singleUploader">
            <ng-container *ngIf="carouselPreviews.length; else carouselPlaceholder">
              <div class="carousel-preview-grid">
                <div class="preview-main">
                  <img [src]="carouselPreviews[0]" alt="Imagem principal">
                  <button type="button" class="remove-thumb" (click)="removeCarouselImage(0); $event.stopPropagation()">&times;</button>
                </div>
                <div class="preview-side">
                  <div class="preview-thumb" *ngFor="let preview of carouselPreviews.slice(1); let idx = index">
                    <img [src]="preview" alt="Imagem do carrossel">
                    <button type="button" class="remove-thumb" (click)="removeCarouselImage(idx + 1); $event.stopPropagation()">&times;</button>
                  </div>
                </div>
              </div>
              <p class="muted-info">{{ carouselPreviews.length }}/{{ maxCarouselImages }} imagens selecionadas</p>
            </ng-container>
            <ng-template #carouselPlaceholder>
              <mat-icon>collections</mat-icon>
              <p>Arraste até {{ maxCarouselImages }} imagens ou clique para selecionar.</p>
            </ng-template>
          </ng-container>
          <ng-template #singleUploader>
            <ng-container *ngIf="!filePreview && filePreviewType !== 'document'; else previewBlock">
              <mat-icon>{{ (isDocumentMode || forceDocumentMode) ? 'description' : 'cloud_upload' }}</mat-icon>
              <p *ngIf="isDocumentMode || forceDocumentMode">Arraste documentos suportados (PDF, DOCX, PPT...) ou clique para enviar.</p>
              <p *ngIf="!(isDocumentMode || forceDocumentMode)">Arraste imagens ou vídeos ou clique para enviar.</p>
            </ng-container>
            <ng-template #previewBlock>
              <ng-container [ngSwitch]="filePreviewType">
                <ng-container *ngSwitchCase="'image'">
                  <img [src]="filePreview" alt="Pré-visualização">
                </ng-container>
                <ng-container *ngSwitchCase="'video'">
                  <video [src]="filePreview" controls muted loop></video>
                </ng-container>
                <div *ngSwitchCase="'document'" class="document-chip">
                  <mat-icon>description</mat-icon>
                  <span>{{ documentPreviewName || 'Documento selecionado' }}</span>
                </div>
              </ng-container>
            </ng-template>
          </ng-template>
        </div>

        <div class="text-field">
          <label for="content_text">Conteúdo do post</label>
          <textarea id="content_text" rows="6" [(ngModel)]="form.content_text" name="content_text"
                    [placeholder]="(isDocumentMode || forceDocumentMode) ? 'Descreva o objetivo do documento e as instruções aos usuários...' : 'Compartilhe novidades, comunicados ou histórias...'"></textarea>
        </div>

        <div class="toggles">
          <mat-slide-toggle [(ngModel)]="form.allow_likes" name="allow_likes" [disabled]="form.show_popup || forceDocumentMode || isDocumentMode">Permitir curtidas</mat-slide-toggle>
          <mat-slide-toggle [(ngModel)]="form.allow_comments" name="allow_comments" [disabled]="form.show_popup || forceDocumentMode || isDocumentMode">Permitir comentários</mat-slide-toggle>
          <mat-slide-toggle [(ngModel)]="form.show_popup" name="show_popup" (change)="onPopupToggle()" [disabled]="forceDocumentMode">Mostrar popup</mat-slide-toggle>
          <mat-slide-toggle [(ngModel)]="form.require_read_confirmation" name="require_read_confirmation" [disabled]="forceDocumentMode" >Confirmar leitura</mat-slide-toggle>
          <mat-slide-toggle [(ngModel)]="form.require_acceptance" name="require_acceptance">Exigir aceite</mat-slide-toggle>
          <mat-slide-toggle *ngIf="isDocumentMode || forceDocumentMode" [(ngModel)]="form.is_public_document" name="is_public_document">
            Documento público
          </mat-slide-toggle>
        </div>

        <div class="popup-config" *ngIf="form.show_popup">
          <label>
            Duração do popup (dias)
            <input type="number" min="1" [(ngModel)]="form.popup_days" name="popup_days">
          </label>
          <p class="popup-hint">Popups desativam curtidas/comentários e exibem apenas uma imagem destacada.</p>
        </div>


        <div class="feedback" *ngIf="feedback" [class.error]="isErrorFeedback">{{ feedback }}</div>

        <div class="actions">
          <button type="submit" [disabled]="isSaving">{{ isSaving ? 'Enviando...' : 'Publicar' }}</button>
        </div>
      </form>
    </div>
  </div>
</div>
